/**
 * OAuth callback handler page
 */
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { LoadingPage } from '../components/common'

export function CallbackPage() {
  const navigate = useNavigate()

  useEffect(() => {
    // Amplify handles the OAuth callback automatically
    // Just wait a moment for the auth state to settle, then redirect
    const timer = setTimeout(() => {
      navigate('/', { replace: true })
    }, 1000)

    return () => clearTimeout(timer)
  }, [navigate])

  return <LoadingPage />
}
